import { Draft, Payload, State } from '@smile-next/uikit';
import { AuthParams } from '@/models/domain/AuthParams';
import { DisplayedErrorMessagePayload } from '@/usecases/DisplayErrorMessageUseCase';
import { DisplayedLambdaErrorMessagePayload } from '@/usecases/DisplayLambdaErrorMessageUseCase';
import { LoadedAuthParamsPayload } from '@/usecases/LoadAuthParamsUseCase';
import { AuthenticatedFailurePayload } from '@/usecases/payload/AuthenticatedFailurePayload';
import { AuthenticatedSuccessPayload } from '@/usecases/payload/AuthenticatedSuccessPayload';
import { UpdatedCloudIdFormPayload } from '@/usecases/payload/UpdatedCloudIdFormPayload';

export class SelectLoginMethodPageState extends State {
    public readonly isAuthenticated?: boolean;
    public readonly additionalMessageSummary?: string;
    public readonly additionalMessageDetails?: string;
    constructor(public readonly authParams?: AuthParams, public readonly errorMessage?: string) {
        super();
    }

    reduce(this: Draft<this>, payload: Payload) {
        if (payload instanceof LoadedAuthParamsPayload) {
            this.authParams = payload.authParams;
        }

        if (payload instanceof UpdatedCloudIdFormPayload) {
            this.authParams = payload.authParams;
        }

        if (payload instanceof AuthenticatedSuccessPayload) {
            this.isAuthenticated = true;
        }

        if (payload instanceof AuthenticatedFailurePayload) {
            this.errorMessage = payload.authenticatedFailurePayloadArgs.error.message;
            this.isAuthenticated = false;
            this.additionalMessageSummary = undefined;
            this.additionalMessageDetails = undefined;
        }

        if (payload instanceof DisplayedErrorMessagePayload) {
            this.errorMessage = payload.errorMessage;
            this.additionalMessageSummary = payload.additionalMessageSummary;
            this.additionalMessageDetails = payload.additionalMessageDetails;
        }

        if (payload instanceof DisplayedLambdaErrorMessagePayload) {
            this.errorMessage = payload.lambdaErrorMessage;
            this.additionalMessageSummary = undefined;
            this.additionalMessageDetails = undefined;
        }
    }

    get isValid() {
        return this.authParams?.cloudId?.isValid;
    }
}
